export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/registration-img.a3aedfd3.svg","height":77,"width":95};